
// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function dataset_afterSave() {
	//Add your code for this event here: 
	$w('#spinner').show();
	$w('#formsbumit').hide();
}

import wixLocation from 'wix-location'
export function setFields() {
	//Add your code for this event here: 
	$w('#dataset1').setFieldValue('serviceBooked',"סיור מדבר יהודה - מתחם התחנה"); //  this page is about a specific service
	$w('#dataset1').setFieldValue('marketingCampaignDetails', 'campaign='+wixLocation.query.c + ' &ad='+  wixLocation.query.ad); // include campaign parameters
}
